"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSectionEnum = void 0;
var SearchSectionEnum;
(function (SearchSectionEnum) {
    SearchSectionEnum["Conversations"] = "Cv";
    SearchSectionEnum["Contacts"] = "Cn";
})(SearchSectionEnum = exports.SearchSectionEnum || (exports.SearchSectionEnum = {}));
